import { Component, Input } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { Busyable } from 'src/app/shared/editors/busyable';
import { AppealActionHistoryRecord } from 'src/app/Services/enforcement.service';

@Component({
    selector: 'app-appeal-action-history-modal',
    template: `
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Appeal Action History</p>
        </header>
        <section class="modal-card-body" style="min-width: 600px;">
          <app-loader [Parent]="this"></app-loader>
          <div class="table-container">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Actioned By</th>
                </tr>
              </thead>
              <tbody>
                @for (action of actions; track action) {
                  <tr>
                    <td>{{action.ActionDateLocalFriendlyString}}</td>
                    <td>{{action.Description}}</td>
                    <td>{{action.ActionedByUserName}}</td>
                  </tr>
                }
                @if (!actions?.length) {
                  <tr>
                    <td colspan="3" class="has-text-centered is-italic has-text-grey">No action history available</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" (click)="close()">Close</button>
        </footer>
      </div>
    </div>
    `,
    standalone: false
})
export class AppealActionHistoryModalComponent extends SimpleModalComponent<{ actions: AppealActionHistoryRecord[] }, void> implements Busyable {
  @Input() actions: AppealActionHistoryRecord[] = [];
  IsBusy: boolean = false;
  IsLoading: boolean = false;
  BusyStarted: any;
  BusyEnded: any;
  LoadingStarted: any;
  LoadingEnded: any;

  Busy() {
    this.IsBusy = true;
    this.BusyStarted?.emit();
  }

  StopBusy() {
    this.IsBusy = false;
    this.BusyEnded?.emit();
  }

  Loading() {
    this.IsLoading = true;
    this.LoadingStarted?.emit();
  }

  StopLoading() {
    this.IsLoading = false;
    this.LoadingEnded?.emit();
  }
}

